const C = require("../constants");

const showToast = (data) => {
    return {
        type: C.SHOW_TOAST,
        data
    }
};

export {showToast};


// WEBPACK FOOTER //
// ./src/actions/ToastAction.js